<template>
  <div class="const">
    <div class="curson_m" v-if="cursonStast">
      <div class="const_pm">
        <div
          class="dp_pm"
          v-for="item in kpPicList"
          v-bind:key="item.id"
          style="height:223px"
          isFullscreen
        >
          <div class="dp_pm_name">{{item.user_name}}</div>
          <div class="imgPic">
            <img :src="item.dupic" preview="0" preview-text="描述文字" width="100%" height="223" />
          </div>
          <div class="tpqp" v-if="item.fullscreenEl">
            <div class="close">
              <i
                class="el-icon-circle-close"
                style="color:#fff;font-size:40px"
                @click.stop="screenfull(item)"
              ></i>
            </div>
            <div class="center">
              <img :src="item.dupic" />
            </div>
          </div>
          <div
            class="dp_pm_footer"
            v-on:mouseover="item.qpmsIcon = true"
            v-on:mouseleave="item.qpmsIcon = false"
            @click.stop="screenfull(item)"
          >
            <label v-if="!item.qpmsIcon">
              <img src="@/assets/sj_icon3.png" />
            </label>
            <label v-if="item.qpmsIcon">
              <img src="@/assets/sj_icon4.png" />
            </label>
          </div>
        </div>
      </div>
      <div class="p_btn">
        <div class="hybb" v-on:click="stastShow()">重新选择电脑</div>
      </div>
    </div>
    <div class="curson_pm" v-if="!cursonStast">
      <div class="curson_t">
        <h3>
          <label></label>
          当前在线主机({{count}})
        </h3>
        <el-collapse v-model="activeNames">
          <el-collapse-item v-for="item of groupList" v-bind:key="item.id" :name="item.id">
            <template slot="title">
              <el-checkbox v-model="item.checked" @change="changeCheck(item)"></el-checkbox>
              {{item.group_name}}({{item.onlineChildren.length}})
            </template>
            <div class="jspm">
              <el-checkbox-group v-model="checkList">
                <el-checkbox
                  v-for="names of item.children"
                  v-bind:key="names.id"
                  :label="names.id"
                  :disabled="names.is_online == 0"
                >
                  <label v-if="names.is_online == 1">
                    <img src="@/assets/pc_on.png" />
                  </label>
                  <label v-if="names.is_online == 0">
                    <img src="@/assets/dp_icon1.png" />
                  </label>
                  {{names.user_name}}
                  <span>IP：{{names.ip}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="p_btns">
        <div class="hybb" v-on:click="wholeChoice()">全选</div>
        <div class="hybb" v-on:click="stastShow()">开始多屏监控</div>
        <label>* 最多只能监控16台主机</label>
      </div>
    </div>
  </div>
</template>
<script>
import { http } from "./../../https";
import { setInterval, clearInterval } from "timers";
export default {
  data() {
    return {
      qpmsIcon: require("@/assets/sj_icon3.png"),
      activeNames: [],
      cursonStast: false,
      kjList: [],
      groupList: [],
      checkList: [],
      kpPicList: [],
      count: 0
    };
  },
  created() {
    this.curronGroup();
  },
  beforeDestroy() {
    if (this.kpPicList.length > 0) {
      for (let d of this.kpPicList) {
        clearInterval(d.timer);
      }
    }
  },
  methods: {
    curronGroup() {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      this.groupList = dataGroup.group;
      this.activeNames = [];
      for (let item of this.groupList) {
        item["children"] = [];
        item["onlineChildren"] = [];
        item["checked"] = false;
        let json = [];
        this.activeNames.push(item.id);
        for (let names of dataGroup.server) {
          if (item.group_name == names.group_name) {
            if (names.is_online == 1) {
              item["onlineChildren"].push(names);
              json.push(names);
            }
          }
        }
        for (let names of dataGroup.server) {
          if (item.group_name == names.group_name) {
            if (names.is_online == 0) {
              json.push(names);
            }
          }
        }
        item["children"] = json;
      }
      for (let names of dataGroup.server) {
        if (names.is_online == "1") {
          this.count++;
        }
      }
    },
    stastShow() {
      if (this.kpPicList.length > 0) {
        for (let d of this.kpPicList) {
          clearInterval(d.timer);
        }
        this.kpPicList = [];
      }
      if (this.checkList.length == 0) {
        this.$message.error("请选择至少一台在线的主机!");
        return false;
      }
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      let json = [];
      for (let names of dataGroup.server) {
        for (let check of this.checkList) {
          if (names.id == check) {
            json.push(names);
          }
        }
      }
      for (let off of json) {
        if (off.is_online == 0) {
          this.$message.error("请选择在线人员!");
          return;
        }
      }
      for (let on of json) {
        this.ryPm(on);
        on["timer"] = setInterval(() => {
          this.ryPm(on);
        }, 5000);
        on["fullscreenEl"] = false;
        on["qpmsIcon"] = false;
        this.kpPicList.push(on);
      }
      this.cursonStast = !this.cursonStast;
    },
    ryPm(e) {
      const user_name = sessionStorage.getItem("user_name");
      const mac = e.mac;
      let macSplit = mac.replace(/-/g, "");
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getRealScreen&quality=100&resolution=1280`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          for (let d of this.kpPicList) {
            if (d.mac == e.mac) {
              this.$set(
                d,
                "dupic",
                `http://${user_name}_${macSplit}.ng.360mon.cn:90/${res.data.img}`
              );
            }
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    wholeChoice() {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      if (this.checkList.length == 0) {
        for (let names of dataGroup.server) {
          this.checkList.push(names.id);
        }
      } else {
        this.checkList = [];
      }
    },
    screenfull(e) {
      console.log(e);
      //this.$set(e, "fullscreenEl", !e.fullscreenEl);
      e.fullscreenEl = !e.fullscreenEl;
    },
    changeCheck(e) {
      if (e.checked) {
        if (e.children.length > 0) {
          for (let names of e.children) {
            this.checkList.push(names.id);
          }
        }
      } else {
        this.checkList = [];
      }
    }
  }
};
</script>
<style scoped>
.tpqp {
  position: fixed;
  background: rgba(000, 000, 000, 0.8);
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999999999999;
}
.tpqp .close {
  text-align: right;
  margin-top: 40px;
  margin-right: 40px;
  cursor: pointer;
}
.tpqp .center {
  display: flex;
  height: 100%;
  margin-top: -40px;
  align-items: center;
  justify-content: center;
}
.tpqp img {
  width: 1200px;
}
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
}
.const .curson_t {
  overflow: auto;
  height: calc(100vh - 320px);
  margin-bottom: 20px;
}
.const .curson_pm {
  margin: 0 20px;
}
.const .curson_pm h3 {
  padding: 18px 0 0 0;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: rgba(70, 70, 70, 1);
  padding-bottom: 10px;
}
.const .curson_pm h3 label {
  border-left: 5px solid #2878ff;
  margin-right: 6px;
}
.const .curson_pm /deep/.el-collapse {
  border-top: none;
  border-bottom: none;
  margin-top: 15px;
}
.const .curson_pm /deep/.el-collapse-item__header {
  border-bottom: none;
  background: #e3e3e3;
  font-size: 16px;
  font-weight: 400;
  color: #5c5b5b;
  text-indent: 15px;
}
.const .curson_pm .jspm {
  margin-top: 15px;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
}
.const .curson_pm .jspm img {
  vertical-align: middle;
  margin-top: -5px;
  margin-right: 5px;
}
.const .curson_pm .jspm span {
  font-size: 12px;
  font-weight: 400;
  color: rgba(178, 178, 178, 1);
  margin-left: 5px;
}
.const .curson_pm .jspm /deep/.el-checkbox {
  margin-top: 15px;
}
.const .const_pm {
  display: flex;
  overflow: auto;
  margin: 0 20px 0 0px;
  height: calc(100vh - 300px);
  flex-wrap: wrap;
  align-items: inherit;
  justify-content: flex-start;
}
.const .dp_pm {
  margin-top: 20px;
  margin-left: 20px;
  width: 357px;
  background: #000;
  background-size: 100% 100%;
  position: relative;
  cursor: pointer;
}
.const .dp_pm .imgPic {
  position: absolute;
  width: 100%;
  z-index: 88;
}
.const .dp_pm .imgPic img {
  width: 100%;
}
.const .dp_pm .dp_pm_name {
  position: absolute;
  width: 200px;
  left: 50%;
  margin-left: -100px;
  padding: 10px 0px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  background: rgba(000, 000, 000, 0.5);
  z-index: 99;
}
.const .dp_pm .dp_pm_name label {
  margin-left: 5px;
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.const .dp_pm .dp_pm_footer {
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
  z-index: 99;
}
.const .p_btn {
  width: 203px;
  margin-left: 20px;
}
.const .p_btn .hybb {
  padding: 8px 24px;
  border: 1px solid rgba(40, 120, 255, 1);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  color: #2878ff;
  margin-right: 25px;
  cursor: pointer;
}
.const .p_btn .hybb:hover {
  background: #2878ff;
  color: #fff;
}
.const .p_btns {
  display: flex;
}
.const .p_btns .hybb {
  padding: 8px 24px;
  border: 1px solid rgba(40, 120, 255, 1);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  color: #2878ff;
  margin-right: 25px;
  cursor: pointer;
}
.const .p_btns .hybb:hover {
  background: #2878ff;
  color: #fff;
}
.const .p_btns label {
  font-size: 14px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
  margin-top: 8px;
}
</style>